<div class="grid-container home-container container">
  <app-kpi
    label="admin.tenant_administration.tenants"
    iconName="customer"
    [source]="sysAdminFacade.numberOfTenants()"
  ></app-kpi>
</div>
